const plan = {
  PLAN_DETAILS: 'PLAN_DETAILS',
}

export default plan



// WEBPACK FOOTER //
// src/components/PlanDetails/actions/actionTypes.js